import { IConnection } from '../interfaces/models/connection'

type TagsSyncListener = (updatedConnections: IConnection[]) => void

let inboxTagsSyncListener: TagsSyncListener | null = null

/** Called from useInboxHandlers when the inbox store is mounted (inside InboxStoreProvider). */
export function setInboxTagsSyncFromConnectionsListener(listener: TagsSyncListener | null) {
    inboxTagsSyncListener = listener
}

/** After bulk tag API; forwards to inbox if the inbox tab is active (listener registered). */
export function notifyInboxTagsUpdatedFromConnections(updatedConnections: IConnection[]) {
    inboxTagsSyncListener?.(updatedConnections)
}

/** After connection profile/field updates (e.g. Update Profile in inbox sidebar). */
export function notifyInboxConnectionsUpdatedFromConnections(updatedConnections: IConnection[]) {
    inboxTagsSyncListener?.(updatedConnections)
}
